import camelize from '../utils/camelize';

const getConfigFromHtml = () => {
  const elem = document.querySelector('[data-config]');
  return elem ? camelize(JSON.parse(elem.textContent || elem.innerText || elem.innerHTML)) : {};
};

export default () => {
  return Object.assign({}, getConfigFromHtml(), {
    apiV4UserCreate: getConfigFromHtml().apigatewayBaseUrl + '/v1.2.0/' + getConfigFromHtml().locale + '/users',
    apiV4UserShow: getConfigFromHtml().apigatewayBaseUrl + '/v1.2.0/' + getConfigFromHtml().locale + '/users/me',
    accountsLoginUrl: getConfigFromHtml().signInUrl,
    authenticationLoginUrl: getConfigFromHtml().myBaseUrl + '/%{locale}/authentication/login/email',
    babbelDomain: getConfigFromHtml().myBaseUrl ? getConfigFromHtml().myBaseUrl.split('my.')[1] : '',
    campaignsClickedPixel: getConfigFromHtml().goBaseUrl + '/%{shortlinkCode}/%{trackingPosition}/clicked.gif',
    eventTracker: getConfigFromHtml().apigatewayBaseUrl + '/v1/events',
    oauthUserRegistration: getConfigFromHtml().homeBaseUrl + '/%{locale}/' +
    'oauth_session/new?learn_lang=%{learningLanguage}&provider=%{provider}&return_to=%{return_to}',
    privacyPage: 'http://about.babbel.com/%{locale}/privacy',
    registrationUrl: getConfigFromHtml().homeBaseUrl + '/%{locale}/registration/new',
    rollbarApiToken: getConfigFromHtml().rollbarApiToken,
    rollbarApiUrl: 'https://api.rollbar.com/api/1/item/',
    termsPage: 'http://about.babbel.com/%{locale}/terms',
    uuid: getConfigFromHtml().uuid
  });
};
